import { useEffect, useState } from "react";
import { Switch, SwitchChangeEvent } from "@progress/kendo-react-inputs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CohortModel,
  DuplicateCohortUsers,
  FetchCohorts,
  UserDup,
} from "@mikros/library";

import { Alert, MenuOptions } from "@mikros/shared-ui";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import ApiServices from "../../../service/apiService";
import { format } from "date-fns";
import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Confirm } from "@mikros/shared-ui";
import { Button } from "@progress/kendo-react-buttons";
import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { useNavigate } from "react-router-dom";

export interface CohortDisplayProps {
  cohort: CohortModel;
  coh: FetchCohorts;
  onReload: () => void;
  onClick: () => void;
  refreshedCohorts: () => void;
  fetcohortUser: (chortId: string) => Promise<FetchCohorts>;
}

export function CohortDisplay(props: CohortDisplayProps) {
  const intl = useIntl();
  const accountInstance = Account.getInstance();
  const navigate = useNavigate();
  const errorInstance = ErrorHandler.getErrorInstance();

  console.log("cohort name in cohortDisplay", props.cohort.cohortName);

  const [isToggled, setIsToggled] = useState(false);
  const [delDialog, setdelDialog] = React.useState<boolean>(false);
  const [onStatus, setOnStatus] = React.useState<boolean>(false);
  const [offStatus, setOffStatus] = React.useState<boolean>(false);
  const [visible, setVisible] = React.useState<boolean>(false);
  const [cohortRename, setCohortRename] = useState(props.cohort.cohortName);
  const [duplicateData, setDuplicateData] = useState(true);
  const [showCohorts, setShowCohorts] = useState(true);
  const [dupCohort, setDupCohort] = useState<DuplicateCohortUsers>({
    users: [{} as UserDup],
  } as DuplicateCohortUsers);

  //eror state
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  React.useEffect(() => {
    setIsToggled(props.cohort.status === "ACTIVE" ? true : false);
  }, [props.cohort.status]);

  const toggleDialog = () => {
    setVisible(!visible);
  };

  const handleTextBoxChange = (text: string) => {
    setCohortRename(text);
  };

  const toggleOnStatus = () => {
    setOnStatus(!onStatus);
  };
  const toggleOffStatus = () => {
    setOffStatus(!offStatus);
  };
  const handleToggle = (event: SwitchChangeEvent) => {
    console.log("Hi i am in handleToggle");
    if (props.cohort.status === "ACTIVE") {
      console.log("Inside in block");
      console.log("Event active value", event.value);
      if (event.value === false) {
        setOnStatus(true);
      } else {
        setOffStatus(true);
      }
    } else if (props.cohort.status === "IN-ACTIVE") {
      console.log("Inside else block");
      console.log("Event inactive value", event.value);

      if (event.value === true) {
        setOffStatus(true);
      } else {
        setOnStatus(true);
      }
    }
  };

  const toggledelDialog = () => {
    setdelDialog(!delDialog);
  };
  const options = [
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "pencil" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="mk-primary-bright"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.renameLabel" }),
      value: "rename",
      labelWidth: 17,
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "copy" as IconName]}
          className="fa-fw w-4 h-4 text-mk-primary-bright"
          color="bg-mk-primary-bright"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.duplicateLabel" }),
      value: "duplicate",
      labelWidth: 17,
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "trash-can" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="bg-mk-primary-bright"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseStattus.DeleteLabel" }),
      value: "delete",
      labelWidth: 17,
    },
  ];

  async function menuSelected(data: any) {
    if (data === "rename") {
      toggleDialog();
    }
    if (data === "duplicate") {
      setDuplicateData(true);
      let body = dupCohort;
      body.accntId = accountInstance.accntId;
      body.cohortName =
        props.cohort.cohortName + intl.formatMessage({ id: "users.copy" });

      body.cohortType = props.cohort.cohortType;
      body.cohortuserCnt = props.cohort.cohortuserCnt;
      body.createdBy = props.cohort.createdBy;
      body.date = props.cohort.date;
      body.description = props.cohort.description;
      body.entryType = props.cohort.entryType;
      body.status = props.cohort.status;
      body.updatedBy = props.cohort.updatedBy;

      const userOfCohorts = await props.fetcohortUser(props.cohort.cohortId);
      body.users = userOfCohorts.cohortUsers;

      console.log("This is the users", body.users);

      console.log("body in cohort dup", body);
      console.log("props.coh.cohortUsers:", props.coh.cohortUsers);
      console.log("fetch cohort", props.coh);
      console.log("body users in duplicate", body.users);

      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            `${accountInstance.accntId}/cohort/${props.cohort.cohortId}/duplicate`,
            "PUT",
            body
          )
          .then(async (res) => {
            if (res && res.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(res.errorMessage);
              return;
            }
            console.log("Duplicate response", res);
            props.onReload();
          });
      }
    }
    if (data === "delete") {
      toggledelDialog();
    }
  }

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  return (
    <div>
      <div className="my-4">
        {errorFlag && (
          <Dialog className="errorDialogue">
            <Alert
              description={intl.formatMessage({
                id: errorInstance.errorCode,
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"errorShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgError",
              })}
              backgroundColor={"mk-red"}
              onClick={() => {
                setErrorFlag(false);
                if (errorInstance.permDenied === true) {
                  navigate("/home");
                } else {
                  navigate("/users");
                }
              }}
            />
          </Dialog>
        )}
        {visible && (
          <Dialog className="renameDialog">
            <Confirm
              successText={intl.formatMessage({ id: "user.cohortList.save" })}
              failureText={intl.formatMessage({
                id: "users.cohortDisplay.cancel",
              })}
              textBoxRequired={true}
              intialTextValue={props.cohort.cohortName}
              onSuccess={() => {
                let body = { ...props.cohort };
                body.cohortName = cohortRename;
                let api = ApiServices.getInstance();
                if (accountInstance.accntId) {
                  api
                    .makeRequest(
                      `${accountInstance.accntId}/cohort/${props.cohort.cohortId}/rename`,
                      "PUT",
                      body
                    )
                    .then(async (res) => {
                      if (res && res.errorMessage) {
                        setErrorFlag(true);
                        await errorInstance.updateErrorCode(res.errorMessage);
                        return;
                      }
                      props.onReload();
                      console.log("form response", res);
                    });
                }
                toggleDialog();
              }}
              onFailure={toggleDialog}
              textBoxValue={handleTextBoxChange}
            />
          </Dialog>
        )}

        {onStatus && (
          <Dialog className="warningDialogue">
            <Confirm
              description={intl.formatMessage({
                id: "users.cohortDisplay.scheduleMessagePause",
              })}
              successText={intl.formatMessage({
                id: "users.cohortList.deletionSuccess",
              })}
              failureText={intl.formatMessage({
                id: "users.cohortList.deletionFailure",
              })}
              icon={"warningShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgWarning",
              })}
              backgroundColor={"mk-orange"}
              onSuccess={() => {
                let body = { ...props.cohort };
                body.status = "IN-ACTIVE";
                let api = ApiServices.getInstance();
                if (accountInstance.accntId) {
                  api
                    .makeRequest(
                      `${accountInstance.accntId}/cohort/${props.cohort.cohortId}/updatestatus`,
                      "PUT",
                      body
                    )
                    .then(async (res) => {
                      if (res && res.errorMessage) {
                        setErrorFlag(true);
                        await errorInstance.updateErrorCode(res.errorMessage);
                        return;
                      }
                      console.log("Status response", res);

                      setIsToggled(false);
                      props.onReload();
                    });
                }

                toggleOnStatus();
              }}
              onFailure={toggleOnStatus}
            />
          </Dialog>
        )}

        {offStatus && (
          <Dialog className="warningDialogue">
            <Confirm
              description={intl.formatMessage({
                id: "users.cohortDisplay.scheduleMessageResume",
              })}
              successText={intl.formatMessage({
                id: "users.cohortList.deletionSuccess",
              })}
              failureText={intl.formatMessage({
                id: "users.cohortList.deletionFailure",
              })}
              icon={"warningShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgWarning",
              })}
              backgroundColor={"mk-orange"}
              onSuccess={() => {
                let body = { ...props.cohort };
                body.status = "ACTIVE";
                let api = ApiServices.getInstance();
                if (accountInstance.accntId) {
                  api
                    .makeRequest(
                      `${accountInstance.accntId}/cohort/${props.cohort.cohortId}/updatestatus`,
                      "PUT",
                      body
                    )
                    .then(async (res) => {
                      if (res && res.errorMessage) {
                        setErrorFlag(true);
                        await errorInstance.updateErrorCode(res.errorMessage);
                        return;
                      }
                      console.log("Status response", res);

                      setIsToggled(true);
                      toggleOffStatus();
                      props.onReload();
                    });
                }

                toggleOffStatus();
              }}
              onFailure={toggleOffStatus}
            />
          </Dialog>
        )}
        {duplicateData && showCohorts && (
          <div
            className="text-black bg-mk-primary-20 hover:bg-mk-primary hover:text-mk-primary-bright 
                        transition-all duration-300 rounded-full h-12 w-full cursor-pointer mt-4 p-2"
          >
            <div
              onClick={() => {
                props.onClick();
              }}
              className="flex justify-center items-center h-full"
            >
              <div className="flex justify-items-end items-start w-1/5 ml-10 font-bold">
                <div className="white-space:nowrap overflow:hidden text-overflow:ellipsis text-base">
                  {props.cohort.cohortName}
                </div>
              </div>

              <div className="flex justify-center items-center w-1/5 text-xs font-semibold">
                <div className="w-3 h-3 text-black rounded-full bg-mk-grey mr-2"></div>
                {props.cohort.cohortuserCnt}{" "}
                <FormattedMessage id="users.cohortDisplay.members" />
              </div>
              <div className="flex justify-center items-center w-1/5 text-xs font-semibold">
                <div className="w-3 h-3 text-black rounded-full bg-mk-grey mr-2"></div>
                <FormattedMessage id="users.cohortDisplay.createdOn" />
                {props.cohort.date &&
                  format(
                    new Date(Date.parse(props?.cohort?.date.split("T")[0])),
                    " dd MMM yyyy"
                  )}
              </div>
              <div
                className="flex justify-center items-center w-1/5"
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                <Switch
                  checked={isToggled}
                  onChange={handleToggle}
                  onLabel={intl.formatMessage({
                    id: "users.cohortDisplay.switchOn",
                  })}
                  offLabel={intl.formatMessage({
                    id: "users.cohortDisplay.switchOff",
                  })}
                />
              </div>
              <div
                className="flex justify-center items-center w-1/5"
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                <MenuOptions
                  options={options}
                  onSelect={(data: any) => {
                    menuSelected(data);
                  }}
                >
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    className="flex items-center justify-center bg-mk-primary-50 hover:bg-gray-300 rounded-full w-8 h-8"
                  >
                    <FontAwesomeIcon
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                      icon={"ellipsis-v"}
                    />
                  </Button>
                </MenuOptions>
              </div>
            </div>
          </div>


        )}

        {delDialog && (
          <Dialog className="warningDialogue">
            <Confirm
              description={intl.formatMessage({
                id: "users.cohortDisplay.deletion",
              })}
              successText={intl.formatMessage({
                id: "users.cohortList.deletionSuccess",
              })}
              failureText={intl.formatMessage({
                id: "users.cohortList.deletionFailure",
              })}
              icon={"warningShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgWarning",
              })}
              backgroundColor={"mk-orange"}
              onSuccess={() => {
                let api = ApiServices.getInstance();
                if (accountInstance.accntId) {
                  api
                    .makeRequest(
                      `${accountInstance.accntId}/cohort/${props.cohort.cohortId}`,
                      "DELETE"
                    )
                    .then((res) => {
                      console.log("del response", res);
                      props.onReload();
                    });
                }
                toggledelDialog();
              }}
              onFailure={toggledelDialog}
            />
          </Dialog>
        )}
      </div>
    </div>
  );
}
